import { parsePhoneNumberFromString, isValidPhoneNumber, CountryCode, PhoneNumber } from 'libphonenumber-js';

export const formatPhoneNumber = (
  number: string,
  country: CountryCode = "US"
): string => {
  try {
    if (isValidPhoneNumber(number, country)) {
      const phoneNumber: PhoneNumber | undefined = parsePhoneNumberFromString(number, country);
      return phoneNumber ? phoneNumber.formatNational() : number;
    }
    return number;
  } catch (error) {
    console.error("Error formatting phone number:", error);
    return number;
  }
}
